
import * as React from "react";

import "./confirm-dialog-2.scss";

import {cs}         from "@Common/react/chain-services";
import {upperCase1} from "@Common/utils/strings";

import {GlobalEventQueue} from "../../../../../browser/global-event-queue";
import {ModalService3}    from "../../../../../modal-service-3/modal-service-3";

export const ConfirmDialog2 = ({next: rootNext}) => cs(
    ["modal", ({}, next1) => ModalService3({
        xToClose: false,
        width: 400,
        next: next1,
        xdQaName: "Confirm",
        rootNext,
    })],
    ["actionContent", ({modal}, next) => next(
        modal.params.actionContent ?? (!!modal.params.actionName && `Are you sure you want to ${modal.params.actionName}?`)
    )],
    ({modal, actionContent}) => (
        <div className="confirm-dialog-2-3e0" onClick={(e) => e.stopPropagation()}>
            <div className="content">
                <div className="message" xd-qa-type="label" xd-qa-name="Confirm Message">
                    {modal.params.message}
                </div>
                {actionContent && (
                    <div className="sub-text" xd-qa-type="label" xd-qa-name="Confirm Question">
                        {actionContent}
                    </div>
                )}
            </div>
            <div className="footer">
                <button
                    className="cancel"
                    xd-qa-type="button"
                    xd-qa-name="Confirm Cancel"
                    onClick={() => modal.close(false)}
                >
                    {modal.params.buttons?.cancelLabel ?? "Cancel"}
                </button>

                {OnGlobalKeyDownEnter({
                    action: () => modal.close(true),
                })}

                <button
                    className="proceed"
                    xd-qa-type="button"
                    xd-qa-name={"Confirm "+ (modal.params.buttons?.confirmLabel ?? upperCase1(modal.params.actionName))}
                    onClick={() => modal.close(true)}
                >
                    {modal.params.buttons?.confirmLabel ?? upperCase1(modal.params.actionName)}
                </button>
            </div>
        </div>
    ),
);

const OnGlobalKeyDownEnter = GlobalEventQueue({
    eventName: "keydown",
    surCheck: (e) => e.key === "Enter",
});
